// images
import blogImg1 from "../images/news01.png";
import blogImg2 from "../images/news02.png";
import blogImg3 from "../images/news03.png";
import blogImg4 from "../images/blog/img-3.jpg";
import blogImg5 from "../images/blog/img-4.jpg";
import blogImg6 from "../images/blog/img-5.jpg";
import blogImg7 from "../images/blog/img-6.jpg";
import blogImg8 from "../images/blog/img-7.jpg";
import blogImg9 from "../images/blog/img-8.jpg";

import bloggrid7 from "../images/blog/img-10.jpg";
import bloggrid8 from "../images/blog/img-11.jpg";
import bloggrid9 from "../images/blog/img-12.jpg";

import blogSingleImg1 from "../images/blog-details/1.jpg";
import blogSingleImg2 from "../images/blog-details/2.jpg";
import blogSingleImg3 from "../images/blog-details/3.jpg";
import blogSingleImg4 from "../images/blog-details/4.jpg";
import blogSingleImg5 from "../images/blog-details/5.jpg";
import blogSingleImg6 from "../images/blog-details/6.jpg";
import blogSingleImg7 from "../images/blog-details/7.jpg";
import blogSingleImg8 from "../images/blog-details/8.jpg";
import blogSingleImg9 from "../images/blog-details/9.jpg";




const blogs = [
    {
        id: '1',
        title: '뉴스의 제목페이지 입니다.',
        title2: 'How to Start a Blog Beginner Best Tooling Agency.',
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food1',
        screens: blogImg1,
        link: 'READ MORE',
        description: `뉴스의 내용입니다.
엠알메탈로는 혁신적인..`,
        author: 'Loura Sweety',
        create_at: '2025-11-07',
        blogSingleImg: blogSingleImg1,
        bloggrid: bloggrid7,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '2',
        title: '뉴스의 제목페이지 입니다.',
        title2: 'How To Start A Blog With WordPress In Steps.',
        subtitle: 'ARCHITECTURE / BY: KARIANAS',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food2',
        screens: blogImg2,
        link: 'READ MORE',
        description: `뉴스의 내용입니다.
엠알메탈로는 혁신적인..`,
        author: 'Loura Sweety',
        create_at: '2025-11-07',
        blogSingleImg: blogSingleImg2,
        bloggrid: bloggrid8,
        comment: '35',
        day: '29',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '3',
        title: '뉴스의 제목페이지 입니다.',
        title2: 'How Long Should a Blog Post Be Everything Theres to Know',
        subtitle: 'ARCHITECTURE / BY: Jon',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food3',
        screens: blogImg3,
        link: 'READ MORE',
        description: `뉴스의 내용입니다.
엠알메탈로는 혁신적인..`,
        author: 'Loura Sweety',
        create_at: '2025-11-07',
        blogSingleImg: blogSingleImg3,
        bloggrid: bloggrid9,
        comment: '35',
        day: '30',
        month: 'MAR',
        blClass: 'format-video',
        animation: '1200',
    },
    {
        id: '4',
        title: 'Nurturing creativity & collaboration.',
        subtitle: 'ARCHITECTURE / BY: Jon',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food4',
        screens: blogImg4,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2024',
        blogSingleImg: blogSingleImg4,
        comment: '35',
        day: '25',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '5',
        title: 'Exploring of a Product Designer.',
        subtitle: 'ARCHITECTURE / BY: Jon',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food4',
        screens: blogImg5,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2024',
        blogSingleImg: blogSingleImg5,
        comment: '35',
        day: '25',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '6',
        title: 'Transform Financial Agency.',
        subtitle: 'ARCHITECTURE / BY: Jon',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food4',
        screens: blogImg6,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2024',
        blogSingleImg: blogSingleImg6,
        comment: '35',
        day: '25',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '7',
        title: 'Weblog publishing tool from Google, for sharing text.',
        subtitle: 'ARCHITECTURE / BY: Jon',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food7',
        screens: blogImg7,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2024',
        blogSingleImg: blogSingleImg7,
        comment: '35',
        day: '25',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '8',
        title: 'How to manage a talented and successful design team.',
        subtitle: 'ARCHITECTURE / BY: Jon',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food8',
        screens: blogImg8,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2024',
        blogSingleImg: blogSingleImg8,
        comment: '35',
        day: '25',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '9',
        title: 'How to bring fold to your startup agency with Arolax.',
        subtitle: 'ARCHITECTURE / BY: Jon',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food9',
        screens: blogImg9,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2024',
        blogSingleImg: blogSingleImg9,
        comment: '35',
        day: '25',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },


];
export default blogs;



